import useLoginWithRedirectAuth from './useLoginWithRedirectAuth';
import useLoginWithRedirectCypress from './useLoginWithRedirectCypress';

const useLoginWithRedirect = window.Cypress ? useLoginWithRedirectCypress : useLoginWithRedirectAuth;

export { useLoginWithRedirect };
